import { useTranslation } from "react-i18next";

const StepsList = ({ steps }) => {
    const { t } = useTranslation();
    return (
        <div className="mt-10">
            <h2 className="text-sm font-semibold text-primary">{t("HELP_HOW_IT_WORKS_LABEL")}</h2>
            <div className="mt-4 rounded-2xl border border-slate-200 bg-white px-4 py-4">
                <ul className="space-y-3 text-sm text-slate-600">
                    {steps.map((step) => (
                        <li key={step} className="flex items-start gap-3">
                            <span className="mt-1 h-2 w-2 rounded-full bg-primary" />
                            {step}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default StepsList;
